import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectUser } from '../../../redux/userSlice'
import ManagerApprovalModal from './ManagerApprovalModal'

export function ManagerApprovalParentModal() {
  const active = useSelector(selectUser)
  const [userPermissions, setUserPermissions] = useState([])

  /**
  * Check if the user has correct permissions
  */
  useEffect(() => {
    if (active.status === 'succeeded' && module) {
      const activePermissions = active.spoofed_user.user_permission_options ? active.spoofed_user.user_permission_options : active.data.user_permission_options
      setUserPermissions(activePermissions)
    }
  }, [active])

  return (
    <ManagerApprovalModal />
  )
}
